<template>
  <div id="topCenter">
    <div class="bg-color-black">
      <div class="cc-header">
        <div class="history_tittxt">历史总金额</div>
        <div class="dynamic_tittxt">实时总金额</div>
      </div>
      <div class="money_txt">
        <div class="title-text history_txt">
          ￥<span v-html="historyTotal"></span>万元
        </div>
        <div class="title-text dynamic_txt">
          ￥<span v-html="total"></span>万元
        </div>
      </div>
      <div class="d-flex jc-center">
        <div id="mapChart" class="mapChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
var storage = window.localStorage;
var region = storage.getItem("region");
const echarts = require("echarts");
export default {
  data() {
    return {
      total: 0,
      historyTotal: 0,
    };
  },
  mounted() {
    this.initTotal();
    this.initMap();
    // 定时器刷新，5秒
    let _this = this;
    setInterval(() => {
      _this.initTotal();
    }, 1000 * 5);
  },
  methods: {
    initTotal() {
      let _this = this;
      this.$http.get("/dataView/pay/getTotalMoney").then((res) => {
        if (res.data.code === 200) {
          _this.total = res.data.money;
          _this.historyTotal = res.data.historymoney;
        }
      });
    },
    initMap() {
      var mapChart = echarts.init(document.getElementById("mapChart"));
      this.$http.get("/dataView/pay/getPayMapDistribution").then((res) => {
        if (res.data.code === 200) {
          var result = res.data.result;
          var mapJosn = "xihe";
          if (region != "false" && this.Map.mapMap.get(region) != undefined) {
            mapJosn = this.Map.mapMap.get(region);
          }
          var option = {
            geo: {
              map: mapJosn,
              label: {
                show: false,
                textStyle: {
                  color: "#0692a4",
                  fontSize: fontSize(0.25),
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              roam: true,
              zoom: 1.2,
              itemStyle: {
                normal: {
                  areaColor: "#142957",
                  borderColor: "#0692a4",
                },
                emphasis: {
                  areaColor: "#0b1c2d",
                },
              },
            },
            series: [
              {
                type: "effectScatter",
                coordinateSystem: "geo",
                zlevel: 1,
                showEffectOn: "render",
                rippleEffect: {
                  brushType: "stroke",
                },
                hoverAnimation: true,
                label: {
                  normal: {
                    formatter: "{b}",
                    position: "top",
                    show: false,
                    textStyle: {
                      fontSize: 25,
                      color: "#f4e925",
                    },
                  },
                  emphasis: {
                    show: true,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "#f4e925",
                    shadowBlur: 11,
                    shadowColor: "#333",
                  },
                },
                data: result,
              },
            ],
          };
          mapChart.setOption(option);
          window.addEventListener("resize", () => mapChart.resize(), false);
        }
      });
    },
  },
};
function fontSize(res) {
  let clientWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (!clientWidth) return;
  let fontSize = 100 * (clientWidth / 750);
  return res * fontSize;
}
</script>

<style lang="scss">
#topCenter {
  height: 62vh;

  .cc-header {
    height: 0.5rem;
    color: #fff;
    font-size: 0.55rem;
    padding-top: 1rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .money_txt {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .title-text {
    height: 2rem;
    font-size: 0.6rem;
    width: 100%;

    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    line-height: 2rem;
  }
  .title-text span {
    font-weight: 600;
    font-size: 0.8rem;
    padding: 0 0.1rem;
  }
  .history_tittxt {
    background-image: -webkit-gradient(
      linear,
      left 0,
      right 0,
      from(rgb(246, 249, 45)),
      to(rgb(25, 197, 216))
    );
    -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
    -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
  }
  .dynamic_tittxt {
    background-image: -webkit-gradient(
      linear,
      left 0,
      right 0,
      from(rgb(246, 249, 45)),
      to(rgb(216, 118, 47))
    );
    -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
    -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
  }

  .history_txt {
    background-image: linear-gradient(135deg, #ffe500, #00e2ff);
  }
  .dynamic_txt {
    background-image: linear-gradient(135deg, #fff36b, #ff5623);
  }

  .mapChart {
    width: 12rem;
    height: 50vh;
    margin-top: -0.5rem;
  }
}
</style>
